import React, {useEffect, useState} from 'react';
import './style.scss'
import HeroInformation from "../Components/HeroInformation";
import {useDispatch, useSelector} from "react-redux";
import {ButtonMUI, LoaderMUI} from "../../shared";
import InfiniteScroll from "react-infinite-scroll-component";
import {
    clearNotificationList,
    getProfileNotifications, readNotificationAll, readNotificationById,
    removeNotificationById, updateNotificationCount
} from "../../redux/actions/profile/profileActions";
import {toast} from "react-toastify";
import NoItems from "../Components/NoItems";
import Notification from "../Components/Notification/Notification";
import LoadPanel from "../Components/LoadPanel";

const Notifications = () => {
    const dispatch = useDispatch();
    const {list, page, hasMore} = useSelector((state) => state.profile.notifications);
    const profileMe = useSelector((state) => state.profile.profileMe);
    const [isActionClicked, setIsActionClicked] = useState(false);

    useEffect(() => {
        if (profileMe?.id) {
            dispatch(getProfileNotifications(1));
        }
        return () => {
            dispatch(clearNotificationList());
            setIsActionClicked(false)
        }
    }, [dispatch, profileMe?.id]);

    const fetchMoreNotifications = () => {
        dispatch(getProfileNotifications(page));
    };

    const handleRemoveNotification = (id) => {
        setIsActionClicked(true)
        dispatch(removeNotificationById(id)).then((res) => {
            if (res.payload) {
                toast.success('Успішно видалено');

                setTimeout(() => {
                    setIsActionClicked(false)
                }, 250)

                if (list.length === 1) {
                    dispatch(getProfileNotifications(1));

                }
            } else {
                setIsActionClicked(false)
            }
        })

    }
    const handleReadNotification = (id, isRead) => {
        if (isRead) return
        setIsActionClicked(true)
        dispatch(readNotificationById(id)).then((res) => {
            if (res.payload) {
                setTimeout(() => {
                    setIsActionClicked(false)
                }, 250)
            } else {
                setIsActionClicked(false)
            }
        })

    }
    const handleReadAllNotification = () => {
        setIsActionClicked(true)
        dispatch(readNotificationAll()).then((res) => {
            if (res.payload) {
                setTimeout(() => {
                    setIsActionClicked(false)
                }, 250)
            } else {
                setIsActionClicked(false)
            }
        })

    }

    return (
        <div className={'notifications'} id={'notifications'}>
            <div className="notifications__inner">
                <HeroInformation
                    title={'Ваші сповіщення'}
                    description={'Усі важливі повідомлення з додатку в одному місці'}
                />
                <ButtonMUI className={'notifications__btn'} onClick={handleReadAllNotification} size={'small'}>Прочитати
                    все</ButtonMUI>

                {list.length <= 0 && !hasMore ? <NoItems title={'Сповіщень не знайдено'}/> : <InfiniteScroll
                    dataLength={list.length}
                    scrollThreshold={0.9}
                    next={fetchMoreNotifications}
                    scrollableTarget="notifications"
                    hasMore={hasMore}
                    loader={<LoadPanel circleSize={40} noBg={true}/>}
                    className="notifications__list"

                >
                    {list.map((notification, index) => {
                        return (
                            <Notification notification={notification} key={index} onRemove={handleRemoveNotification}
                                          onRead={handleReadNotification}/>
                        )
                    })}
                </InfiniteScroll>}


                {isActionClicked && <LoaderMUI
                    circleSize={40}/>}

            </div>
        </div>
    );
};
export default Notifications;